// ModalContent.js
import React, {useState} from "react";
import Select from "react-select";

// Shared by Recipe Planning, RM Recipe Planning (event and day) and Production Support.
//
// Opt-in prop, defaulting to the previous behaviour:
//   showPlannedQty:  a "Planned RM Qty" box beside the ingredient, and its value is passed to
//                    handleAddIngredient as a second argument. Recipe Planning asks for it;
//                    Production Support adds an ingredient without a quantity and does not.
//   showMainItem:    a "Main Item" checkbox, passed to handleAddIngredient as a third argument,
//                    so an ingredient can be added straight into the Main Ingredients section
//                    rather than added and then ticked in the table.
const ModalContent = ({ showModal, setShowModal, ingredientList, handleAddIngredient, ingredientDetail, showPlannedQty = false, showMainItem = false }) => {
  const [selectedItem, setSelectedItem] = useState({});
  const [plannedQty, setPlannedQty] = useState("");
  const [isMain, setIsMain] = useState(false);
  const [disableButton, setDisableButton] = useState(false);

  const handelChangeSelect = (data) => {
    
    const found = ingredientDetail.some(item => item.ingredient_id === data.value);
    if (found) {
      alert('Error: ingredient already exists');
      setDisableButton(true);
    } else {
      setSelectedItem(data)
      setDisableButton(false);
    }
    
  }
  const handleAddItem =  () => {
  // console.log(ingredientList[0]);
  handleAddIngredient(selectedItem, plannedQty, isMain);
  // Cleared for the next ingredient: screens that add without reloading would otherwise reopen
  // the modal on the last one's quantity and Main Item tick.
  setSelectedItem({});
  setPlannedQty("");
  setIsMain(false);
  setShowModal(false)
  };

  // Nothing to save without an ingredient, whatever quantity has been typed beside it.
  const canSave = !disableButton && !!selectedItem?.value;

  const handleCancel = () => {
    setSelectedItem({});
    setPlannedQty("");
    setIsMain(false);
    setDisableButton(false);
    setShowModal(false);
  };
  return (
    <>
      {showModal ? (
        <>
          {/* Sized to the screen rather than to its own content. It was w-auto with no room
              reserved at the edges, inside a backdrop that hides horizontal overflow -- so on a
              phone the box grew to whatever the heading and the buttons wanted and the right of
              it, where Cancel and Save sit, went under the edge and could not be reached. The
              heading drops a size below `sm` for the same reason. */}
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 px-4 outline-none focus:outline-none">
            <div className="relative w-full my-6 mx-auto max-w-3xl sm:w-auto sm:min-w-[24rem]">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-4 sm:p-5 border-b border-solid border-blueGray-200 rounded-t">
                  <h3 className="text-xl sm:text-3xl font-semibold">
                    Add Ingredient
                  </h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={handleCancel}
                  >
                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>
                
                <div className="relative p-6 flex-auto space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Ingredient</label>
                {/* The option list is rendered into the body: left in place it is laid out
                    inside the backdrop above, which hides horizontal overflow, so an ingredient
                    carrying both its names was cut off at the edge of the box on a phone -- and
                    the list is the one control here that has to be usable for anything to be
                    added at all. */}
                <Select
                    
                    classNamePrefix="select"
                    className='basic-multi-select'
                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                    name="item"
                    onChange={(selectedOptions) => handelChangeSelect(selectedOptions)}
                    options={ingredientList.map(item => ({
                        value: item.id,
                        label: `${item.ingredient} ${item.eng_name ? `(${item.eng_name})` : ''}`,
                        name: item.ingredient,
                        data: item,
                        
                    }))}
                    placeholder="Item List"
                    filterOption={(option, inputValue) => {
                        return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                    }}
                />  
                </div>
                {showPlannedQty && (
                  <div>
                    <label htmlFor="modal_planned_qty" className="block text-sm font-medium text-gray-700 mb-1">Planned RM Qty</label>
                    <input
                      id="modal_planned_qty"
                      type="number"
                      step="0.01"
                      min="0"
                      placeholder="Planned RM Qty"
                      value={plannedQty}
                      onChange={(e) => setPlannedQty(e.target.value)}
                      onWheel={(e) => e.target.blur()}
                      onKeyDown={(e) => { if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); } }}
                      className="block w-full rounded-md border border-gray-300 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                    />
                  </div>
                )}
                {showMainItem && (
                  <div className="flex items-center">
                    <input
                      id="modal_is_main"
                      type="checkbox"
                      checked={isMain}
                      onChange={(e) => setIsMain(e.target.checked)}
                      className="w-4 h-4 accent-blue-500 cursor-pointer"
                    />
                    <label htmlFor="modal_is_main" className="ml-2 text-sm font-medium text-gray-700 cursor-pointer">
                      Main Item
                    </label>
                  </div>
                )}
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                  <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                  <button
                    className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 disabled:opacity-50"
                    type="button"
                    disabled={!canSave}
                    onClick={() => handleAddItem()}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default ModalContent;
